export default "__VITE_ASSET__CVroJlQS__"